import SkillsItem from "./Item";

export default SkillsItem;
